import { IonButton, IonCol, IonContent, IonFooter, IonHeader, IonIcon, IonInput, IonModal, IonRow, IonSpinner, IonText, IonTitle, IonToolbar } from '@ionic/react';
import { useEffect, useState } from 'react';
import { useAppContext } from '../../services/app-context.service';
import { statusWishlistProduct, toggleWishlistProduct } from '../../services/account/wishlist.service';
import { heart, heartOutline } from 'ionicons/icons';
type Props = {
    id: number
}
const ProductWishlistButton: React.FC<Props> = ({ id }) => {
    const [inWishlist, setInWishlist] = useState(false)
    const [WishlistBtnDisabled, setWishlistBtnDisabled] = useState(false)
    const { user } = useAppContext()
    useEffect(() => {
        if (user.token) {
            statusWishlistProduct(id).then((res) => {
                setInWishlist(res.status)
            })
        }
    }, [id])
    function onToggle() {
        setWishlistBtnDisabled(true)
        toggleWishlistProduct(id).then((res) => {
            setInWishlist(res.type == 'success')
        }).finally(() => {
            setWishlistBtnDisabled(false)
        })
    }
    if (!user.token) {
        return null
    }

    return <IonButton onClick={onToggle} disabled={WishlistBtnDisabled} fill='outline' color='danger'>
        {WishlistBtnDisabled ? <IonSpinner /> : <IonIcon icon={inWishlist ? heart : heartOutline} />}
    </IonButton>
};

export default ProductWishlistButton;
